import { configureStore } from '@reduxjs/toolkit';
import soilProfiles, { ISoilPageModel } from './reducer/soilProfile';
import referenceData, { ISoilPropertyPageModel } from './reducer/referenceData';
import soilAnalyses, { soilAnalysesModel } from './reducer/soilAnalyses';
import common, { commonModel } from './reducer/common';
import menuSelected, { IMenuSelectedModel } from './reducer/menuSelected';
import soilUser, { IUserModel } from './reducer/soilUser';
import soilprofileCreate, {ISoilProfileData} from './reducer/SoilCreatProfiles';
import soilSerach, { ISearchModel } from './reducer/soilSerach';
import weatherStation, { IWeatherStationReduxModel } from './reducer/weatherStation';
import agrialertUser, { IAgrialertUserModel } from './reducer/agrialertUser';
import agrialertTemplate, { IAgrialertTemplateModel } from './reducer/agrialertTemplate';

import userManagemnetData, { IUserManagemnetDataPageModel } from './reducer/userManagement';
const store = configureStore({
    reducer: {
        soilPageData: soilProfiles,
        referencePageData: referenceData,
        soilAnalysesData:soilAnalyses,
        commonData:common,
        menuSelected,
        soilUser,
        userManagemnetPageData: userManagemnetData,
        soilprofileCreateData: soilprofileCreate,
        soilSearchPageData: soilSerach,
        weatherStation: weatherStation,
        // agrialert
        agrialertUser,
        agrialertTemplate
    },
});

// store's type define here
export type RootState = {
    soilPageData: ISoilPageModel
    referencePageData: ISoilPropertyPageModel
    soilAnalysesData:soilAnalysesModel
    commonData:commonModel
    menuSelected: IMenuSelectedModel
    soilUser: IUserModel
    userManagemnetPageData: IUserManagemnetDataPageModel
    soilprofileCreateData: ISoilProfileData
    soilSearchPageData: ISearchModel
    weatherStation: IWeatherStationReduxModel
    // agrialert
    agrialertUser: IAgrialertUserModel,
    agrialertTemplate: IAgrialertTemplateModel
}

export type AppDispatch = typeof store.dispatch;
export default store;